import { useMemo } from 'react';
import { 
  CLIENTE_ID_ATENTUS, 
  CLIENTE_ID_MOVISTAR_PERU,
  CLIENTE_ID_PICHINCHA,
  CLIENTE_ID_BCH
} from '../common/globals/constants';

export const checkClientAccess = (clientIdToCheck) => {
  const raw = sessionStorage.getItem('client_id');
  if (raw == null || raw === '') return false;
  return Number(raw) === clientIdToCheck;
};

export const clientAccessHelpers = {
  isAtentusClient: () => checkClientAccess(CLIENTE_ID_ATENTUS),
  isMovistarPeruClient: () => checkClientAccess(CLIENTE_ID_MOVISTAR_PERU),
  isPichinchaClient: () => checkClientAccess(CLIENTE_ID_PICHINCHA),
  isBCHClient: () => checkClientAccess(CLIENTE_ID_BCH),
  isSpecificClient: (id) => checkClientAccess(id),
};

export function useClientAccess() {
  return useMemo(() => clientAccessHelpers, []);
}
